import { createSelector } from '@reduxjs/toolkit';

import { projectSelector } from 'src/selectors/project';

export const diagramSnapshotSelector = (projectId: string) =>
  createSelector(
    projectSelector(projectId),
    (project) => project?.diagram || null
  );

export const isDraftDiagramSelector = (projectId: string) =>
  createSelector(diagramSnapshotSelector(projectId), (diagram) =>
    Boolean(diagram?.model.modelData.draftData)
  );
